import { createAsyncThunk } from '@reduxjs/toolkit';

import BorrowerApi, { UpdateBorrowerDto } from 'api/BorrowerApi';

export const updateBorrowerThunk = (borrowerApi: BorrowerApi) =>
  createAsyncThunk('auth/UpdateBorrower', async (updateBorrowerDto: UpdateBorrowerDto) => {
    return await borrowerApi.updateBorrower(updateBorrowerDto);
  });
